// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","131":"41250b92","189":"336c2a5d","491":"5227ff75","995":"ee73ee9e"}[chunkId] + ".js";
};